import { AosrAct } from '../types';

export function generateAosrHtml(act: AosrAct, project: any, materials: any[] = []): string {
  const materialsListHtml = materials.length > 0
    ? materials.map((m, idx) => `${idx + 1}. ${m.name} (${m.specification || 'ГОСТ'}), Сертификат: ${m.cert_number || '№ RU C-RU.АБ29'}`).join('<br>')
    : '1. Кабель силовой ВВГнг(А)-LS 3х2.5 кв.мм (ГОСТ 31996-2012, Сертификат соответствия № RU C-RU.АБ29.В.00123/24)<br>2. Труба гибкая гофрированная ПВХ d20мм';

  return `
<!DOCTYPE html>
<html lang="ru">
<head>
  <meta charset="UTF-8">
  <title>АКТ ОСВИДЕТЕЛЬСТВОВАНИЯ СКРЫТЫХ РАБОТ ${act.actNumber}</title>
  <style>
    body { font-family: 'Times New Roman', Times, serif; font-size: 13pt; line-height: 1.35; margin: 40px; color: #000; }
    .header { text-align: center; font-weight: bold; margin-bottom: 20px; text-transform: uppercase; font-size: 14pt; }
    .sub-header { text-align: center; font-size: 11pt; margin-bottom: 25px; }
    .meta-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 11pt; }
    .meta-table td { padding: 4px 8px; vertical-align: top; }
    .meta-label { font-weight: bold; width: 35%; }
    .underline { border-bottom: 1px solid #000; display: inline-block; width: 100%; min-height: 18px; }
    .section-title { font-weight: bold; margin-top: 15px; margin-bottom: 5px; }
    .field-value { font-weight: normal; border-bottom: 1px solid #000; padding: 2px 5px; }
    .signatures { margin-top: 40px; page-break-inside: avoid; }
    .sign-row { display: flex; justify-content: space-between; margin-bottom: 25px; }
    .sign-item { width: 45%; }
    .sign-line { border-bottom: 1px solid #000; margin-top: 30px; }
    .sign-caption { font-size: 9pt; text-align: center; color: #444; }
    @media print {
      body { margin: 15mm; }
      .no-print { display: none; }
    }
  </style>
</head>
<body>
  <div class="no-print" style="margin-bottom: 20px; padding: 12px; background: #e2e8f0; border-radius: 8px; text-align: right;">
    <button onclick="window.print()" style="background: #0284c7; color: white; border: none; padding: 8px 18px; font-size: 14px; font-weight: bold; border-radius: 6px; cursor: pointer;">
      🖨️ Распечатать / Экспорт в PDF
    </button>
  </div>

  <div class="sub-header">Приложение № 3 к РД-11-02-2006</div>

  <div class="header">
    АКТ<br>
    освидетельствования скрытых работ<br>
    № ${act.actNumber}
  </div>

  <table class="meta-table">
    <tr>
      <td class="meta-label">Объект капитального строительства:</td>
      <td><strong>${project?.name || act.project_name || 'ЖК «Северная Звезда»'}</strong>, ${project?.address || 'г. Москва, ул. Полярная, д. 42'}</td>
    </tr>
    <tr>
      <td class="meta-label">Застройщик (технический заказчик):</td>
      <td>${project?.customer || 'ООО «СеверЗастрой»'}</td>
    </tr>
    <tr>
      <td class="meta-label">Генеральный подрядчик:</td>
      <td>${project?.generalContractor || 'АО «ГлавСпецСтрой»'}</td>
    </tr>
    <tr>
      <td class="meta-label">Лицо, осуществляющее строительство (Подрядчик):</td>
      <td><strong>${project?.subcontractor || 'ООО «ЭлектроМонтажСтрой»'}</strong></td>
    </tr>
    <tr>
      <td class="meta-label">Лицо, осуществляющее строительный контроль:</td>
      <td>${project?.techSupervision || 'ООО «ТехСтройКонтроль»'}</td>
    </tr>
  </table>

  <p><strong>Дата составления:</strong> «____» ________________ 2026 г.</p>

  <p><strong>Комиссия в составе представителей:</strong></p>
  <p>1. Представителя застройщика (технадзора): <u>Инженер технадзора Смирнов А.В.</u></p>
  <p>2. Представителя лица, осуществляющего строительство: <u>${act.createdByPto}</u></p>

  <p>произвела осмотр работ, выполненных <u>ООО «ЭлектроМонтажСтрой»</u></p>

  <div class="section-title">1. К освидетельствованию предъявлены следующие работы:</div>
  <div class="field-value"><strong>${act.title}</strong> (${act.block_name || 'Блок А'}, ${act.floor_name || '4 этаж'}, ${act.zone_name || 'Стояк СТ-1'})</div>

  <div class="section-title">2. Работы выполнены по проектной документации:</div>
  <div class="field-value">Рабочая документация <strong>${act.projectCode}</strong>, ${act.projectDrawings}</div>

  <div class="section-title">3. При выполнении работ применены строительные материалы и оборудование:</div>
  <div class="field-value">${materialsListHtml}</div>

  <div class="section-title">4. Даты производства работ:</div>
  <div class="field-value">Начало работ: <strong>${act.startDate}</strong> г. &nbsp;&nbsp;&nbsp;&nbsp; Окончание работ: <strong>${act.endDate}</strong> г.</div>

  <div class="section-title">5. Решение комиссии:</div>
  <p>Работы выполнены в полном соответствии с проектной документацией, СП 76.13330.2016 «Электротехнические устройства», ПУЭ 7-е изд. и требованиями технических регламентов. На основании изложенного <strong>разрешается производство последующих работ</strong> (зашивка ГКЛ / устройство подвесных потолков / чистовая отделка).</p>

  <div class="signatures">
    <div class="sign-row">
      <div class="sign-item">
        <p><strong>Представитель Заказчика (Технадзор):</strong></p>
        <div class="sign-line"></div>
        <div class="sign-caption">(подпись, расшифровка подписи)</div>
      </div>
      <div class="sign-item">
        <p><strong>Представитель Подрядчика (ЭОМ):</strong></p>
        <div class="sign-line"></div>
        <div class="sign-caption">(${act.createdByPto})</div>
      </div>
    </div>
  </div>
</body>
</html>
  `;
}
